module.exports = ".error-message {\n  color: var(--hue-red); }\n\n.grid-height {\n  height: calc(100vh - 200px) !important; }\n"